<a class="d-flex gap-3 align-items-center" [routerLink]="'/settings'" [routerLinkActive]="'active'">
    <span class="initials-badge">
        {{userInitials}}
    </span>
</a>